import axios from "axios";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      examStarted: false,
      showResults: false,
      showReview: false,
      // 考试相关数据
      allQuestions: [],
      easyQuestions: [],
      hardQuestions: [],
      currentQuestionIndex: 0,
      selectedAnswer: "",
      userAnswers: [],
      score: 0,
      examPhase: "easy",
      // 结果相关
      finalScore: 0,
      easyCorrect: 0,
      hardCorrect: 0,
      // 用于显示答案（提交后）
      showAnswer: false
    };
  },
  async mounted() {
    // 隐藏菜单栏和其他元素
    const menu = document.getElementById("menu");
    const showAfterLogin = document.getElementById("showAfterLogin");
    if (menu) menu.style.display = "none";
    if (showAfterLogin) showAfterLogin.style.display = "none";
  },
  computed: {
    currentQuestion() {
      return this.allQuestions[this.currentQuestionIndex] || {};
    },
    totalQuestions() {
      return this.allQuestions.length;
    },
    maxScore() {
      return this.totalQuestions * 10;
    }
  },
  methods: {
    getOptionText(key) {
      if (!this.currentQuestion) return "";
      const optionMap = {
        A: this.currentQuestion.optionA,
        B: this.currentQuestion.optionB,
        C: this.currentQuestion.optionC,
        D: this.currentQuestion.optionD
      };
      return optionMap[key] || "";
    },
    getOptionFromQuestion(question, key) {
      const optionMap = {
        A: question.optionA,
        B: question.optionB,
        C: question.optionC,
        D: question.optionD
      };
      return optionMap[key] || "";
    },
    selectAnswer(answer) {
      this.selectedAnswer = answer;
    },
    // 点击开始考试按钮
    async startExam() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 随机获取10道题（1-3星难度）
        let params = {
          num: 10
        };
        let resp1 = await axios.post("https://backend.wonology.com/exam/randomGetQuestions", params);
        if (resp1.data.code == "0000") {
          this.easyQuestions = resp1.data.data;
          if (this.easyQuestions.length < 10) {
            alert("题目数量不足，请确保数据库中有足够的1-3星题目！");
            return;
          }
          this.allQuestions = [...this.easyQuestions];
          this.userAnswers = new Array(12).fill("");
          this.currentQuestionIndex = 0;
          this.selectedAnswer = "";
          this.score = 0;
          this.examPhase = "easy";
          this.examStarted = true;
          this.showResults = false;
          this.showAnswer = false;
        } else {
          console.error("开始考试失败:", resp1.data.msg.toString());
          alert("开始考试失败: " + resp1.data.msg.toString());
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    async loadHardQuestions() {
      try {
        // 计算前10题得分
        this.easyCorrect = 0;
        for (let i = 0; i < 10; i++) {
          if (this.userAnswers[i] === this.easyQuestions[i].answer) {
            this.easyCorrect++;
          }
        }
        const easyScorePercentage = this.easyCorrect / 10 * 100;
        const hardDifficulty = easyScorePercentage >= 80 ? 5 : 4;

        // 获取2道高难度题目
        const hardResponse = await axios.get(`/api/questions/hard?difficulty=${hardDifficulty}&count=2`);
        this.hardQuestions = hardResponse.data;
        if (this.hardQuestions.length < 2) {
          // 如果指定难度题目不足，尝试获取其他高难度题目
          const fallbackDifficulty = hardDifficulty === 5 ? 4 : 5;
          const fallbackResponse = await axios.get(`/api/questions/hard?difficulty=${fallbackDifficulty}&count=2`);
          this.hardQuestions = fallbackResponse.data;
        }
        if (this.hardQuestions.length < 2) {
          alert("高难度题目不足，考试将只包含10道题目！");
          return false;
        }

        // 添加到题目列表
        this.allQuestions = [...this.easyQuestions, ...this.hardQuestions];
        this.userAnswers = [...this.userAnswers.slice(0, 10), "", ""];
        this.currentQuestionIndex = 10;
        this.selectedAnswer = "";
        this.examPhase = "hard";
        return true;
      } catch (error) {
        console.error("加载高难度题目失败:", error);
        alert("加载高难度题目失败: " + (error.response?.data?.message || error.message));
        return false;
      }
    },
    prevQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
        this.selectedAnswer = this.userAnswers[this.currentQuestionIndex] || "";
      }
    },
    async nextQuestion() {
      if (!this.selectedAnswer) return;

      // 保存当前答案
      this.userAnswers[this.currentQuestionIndex] = this.selectedAnswer;

      // 检查是否是最后一题
      if (this.currentQuestionIndex === this.totalQuestions - 1) {
        await this.submitExam();
        return;
      }

      // 检查是否需要加载高难度题目
      if (this.currentQuestionIndex === 9 && this.examPhase === "easy") {
        const success = await this.loadHardQuestions();
        if (!success) {
          // 如果加载失败，直接提交
          await this.submitExam();
          return;
        }
      }

      // 移动到下一题
      this.currentQuestionIndex++;
      this.selectedAnswer = this.userAnswers[this.currentQuestionIndex] || "";
    },
    async submitExam() {
      // 计算最终得分
      this.score = 0;
      this.easyCorrect = 0;
      this.hardCorrect = 0;

      // 计算前10题
      for (let i = 0; i < Math.min(10, this.allQuestions.length); i++) {
        if (this.userAnswers[i] === this.allQuestions[i].answer) {
          this.score += 10;
          this.easyCorrect++;
        }
      }

      // 计算后2题（如果有）
      if (this.allQuestions.length > 10) {
        for (let i = 10; i < this.allQuestions.length; i++) {
          if (this.userAnswers[i] === this.allQuestions[i].answer) {
            this.score += 10;
            this.hardCorrect++;
          }
        }
      }
      this.finalScore = Math.round(this.score / this.maxScore * 100);
      this.showResults = true;
      this.examStarted = false;
      this.showAnswer = true;
    },
    getUserAnswer(index) {
      return this.userAnswers[index] || "";
    },
    getScoreColor() {
      if (this.finalScore >= 90) return "#10b981";
      if (this.finalScore >= 80) return "#3b82f6";
      if (this.finalScore >= 70) return "#f59e0b";
      return "#ef4444";
    },
    reviewAnswers() {
      this.showReview = true;
    },
    restartExam() {
      this.showResults = false;
      this.showReview = false;
      this.examStarted = false;
      this.allQuestions = [];
      this.easyQuestions = [];
      this.hardQuestions = [];
      this.currentQuestionIndex = 0;
      this.selectedAnswer = "";
      this.userAnswers = [];
      this.score = 0;
      this.examPhase = "easy";
      this.showAnswer = false;
    }
  }
};